/**
 * Date-extensions locale Marathi [mr]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('mr', {
    monthNames: ['जानेवारी','फेब्रुवारी','मार्च','एप्रिल','मे','जून','जुलै','ऑगस्ट','सप्टेंबर','ऑक्टोबर','नोव्हेंबर','डिसेंबर'],
    monthShortNames: ['जाने.','फेब्रु.','मार्च.','एप्रि.','मे.','जून.','जुलै.','ऑग.','सप्टें.','ऑक्टो.','नोव्हें.','डिसें.'],
    dayNames: ['रविवार','सोमवार','मंगळवार','बुधवार','गुरूवार','शुक्रवार','शनिवार'],
    dayShortNames: ['रवि','सोम','मंगळ','बुध','गुरू','शुक्र','शनि']
});
